import React, { useEffect } from "react";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="legal-content">
          <h1 className="legal-title">Privacy Policy</h1>
          <p className="legal-effective">Effective Date: June 1, 2025</p>
          <p className="legal-effective">Last Reviewed: August 20, 2026</p>
          
          <p className="legal-intro">
            Avenir AI respects your privacy and is committed to protecting your personal 
            information. This Privacy Policy explains how we collect, use, store, and 
            safeguard the data we receive through our services, platform, and website.
          </p>

          <div className="legal-section">
            <h2>1. Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul>
              <li>Personal identifiers (e.g., name, email, company)</li>
              <li>Health-related data (e.g., wellness score, benefits usage) – only when authorized</li>
              <li>Device and usage data (e.g., browser type, IP address)</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>2. How We Use Information</h2>
            <p>We use your data to:</p>
            <ul>
              <li>Provide and personalize our services</li>
              <li>Analyze trends and optimize performance</li>
              <li>Communicate with you regarding your account and services</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>3. Data Storage and Security</h2>
            <p>
              We host data securely on Google Cloud Platform in the US multi-region. 
              All sensitive data is encrypted at rest and in transit. Access is limited 
              to authorized personnel only.
            </p>
          </div>

          <div className="legal-section">
            <h2>4. Third-Party Sharing</h2>
            <p>
              We do not sell your data. We only share data with vendors and subprocessors 
              under signed agreements (e.g., BAAs) that enforce strict data protection standards.
            </p>
          </div>

          <div className="legal-section">
            <h2>5. Your Rights</h2>
            <p>
              You may request access, correction, or deletion of your personal data by 
              emailing <a href="mailto:info@avenir.com.ai">info@avenir.com.ai</a>. We will 
              respond in accordance with applicable laws (e.g., HIPAA, CCPA).
            </p>
          </div>

          <div className="legal-section">
            <h2>6. Cookies and Tracking</h2>
            <p>
              We use cookies and similar technologies for analytics and improving user 
              experience. You may control cookies through your browser settings.
            </p>
          </div>

          <div className="legal-section">
            <h2>7. Changes to This Policy</h2>
            <p>
              We may update this policy occasionally. Any significant changes will be 
              communicated on our website or by direct email notification.
            </p>
          </div>

          <div className="legal-contact-note">
            <p>
              If you have questions or concerns about your data, please contact our 
              Data Protection Officer (Andres Carro) at{" "}
              <a href="mailto:andres@avenir.com.ai">andres@avenir.com.ai</a> or our general
              helpline at <a href="mailto:info@avenir.com.ai">info@avenir.com.ai</a>.
            </p>
          </div>
        </div>
      </section>

      <section className="legal-cta">
        <h2>Have Questions?</h2>
        <p>Our team is happy to help you understand how your data is used and protected.</p>
        <a href="mailto:privacy@avenir.com.ai" className="legal-cta-button">
          Email Privacy Team
        </a>
      </section>
    </div>
  );
};

export default PrivacyPolicy;